<template lang="html">
  <div>
    <div
      class="row et_row_complete text-center p-0 py-4 cpl-event col-12 col-md-6 m-auto"
    >
      <!-- charity -->
      <div class="col-6">
        <div
          :title="$store.state.selected_charity.BeneficiaryName"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="$store.state.selected_charity.BeneficiaryImagePath"
            class="card-img-top img-fluid"
            alt=""
          >
        </div>
        <p>
          {{ $store.state.selected_charity.BeneficiaryName }}
        </p>
      </div>
      <!-- event -->
      <div class="col-6">
        <div
          :title="$store.state.selected_event.EventName"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="
              $gfImagePlugin.getImageWithResolution(
                $store.state.selected_event.EventImagePath,
                1000
              )
            "
            class="card-img-top img-fluid"
            alt=""
          >
        </div>
        <p>
          {{ $store.state.selected_event.EventName }}
        </p>
      </div>
    </div>
    <div
      v-if="!$store.state.userIsActivatingCreatedPage"
      class="row col-lg-6 mt-4 m-auto"
    >
      <TeamDetails />
    </div>
    <div class="col-lg-6 m-auto">
      <div class="row justify-content-md-center gf-connect-fb">
        <template v-if="$store.state.userLogon">
          <Logged
            @submitFormComplete="$_createFundraisingPageMixin_submitComplete"
          />
        </template>
        <template v-else>
          <Login
            v-if="$store.state.loginStatus == 'login'"
            @StatusCheckLogin="StatusCheckLogin"
          />
          <ForgotPassword
            v-else-if="$store.state.loginStatus == 'forgot'"
            @StatusCheckLogin="StatusCheckLogin"
          />
          <Register v-else @StatusCheckLogin="StatusCheckLogin" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Login from "../login/Login.vue";
import Logged from "../login/Logged.vue";
import ForgotPassword from "../inc/forgetpassword.vue";
import Register from "../login/Register.vue";
import TeamDetails from "./details.vue";
import CreateFundraisingPageMixin from "../inc/CreateFundraisingPageMixin.vue";
import axios from "axios";

export default {
  name: "TeamComplete",

  components: {
    Login,
    Logged,
    ForgotPassword,
    Register,
    TeamDetails
  },

  mixins: [CreateFundraisingPageMixin],

  async mounted() {
    var self = this;
    (this.pageType = "T"), (this.teamId = 0);
    this.charityId = this.$store.state.selected_charity.beneficiaryId;
    this.eventCampaignId = this.$store.state.selected_event.EventCampaignId;
    this.teamName = this.$store.state.details_team.teamName;
    this.createIndividualPageForTeam = this.$store.state.createIndividualPage;

    try {
      await this.$_createFundraisingPageMixin_loadVueAnalytics();
    } catch (e) {
      console.log("Failed to load google Analytics.");
    }
  },

  methods: {
    StatusCheckLogin(value) {
      this.$store.commit("setLoginStatus", value);
    }
  }
};
</script>
<style scoped>
.card-img-top.img-fluid {
  width: 100%;
  height: 8vw;
  object-fit: contain;
}
</style>
